import { render, staticRenderFns } from "./InternetAndMobileShowcase.vue?vue&type=template&id=ea97444a&scoped=true&"
import script from "./InternetAndMobileShowcase.vue?vue&type=script&lang=js&"
export * from "./InternetAndMobileShowcase.vue?vue&type=script&lang=js&"
import style0 from "./InternetAndMobileShowcase.vue?vue&type=style&index=0&id=ea97444a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea97444a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37556953/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea97444a')) {
      api.createRecord('ea97444a', component.options)
    } else {
      api.reload('ea97444a', component.options)
    }
    module.hot.accept("./InternetAndMobileShowcase.vue?vue&type=template&id=ea97444a&scoped=true&", function () {
      api.rerender('ea97444a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/orange/broadband/demands/showcase/internetandmobileoffers/components/InternetAndMobileShowcase.vue"
export default component.exports